module.exports = __webpack_public_path__ + "img/balance.10050b1d.jpg";